import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";


export const notificationSettingStyle = StyleSheet.create({
    containerView: {
        flex: 1,
    },
    viewStyle: {
        flexDirection: 'row', backgroundColor: appColors.light
    },
    viewContainer: {
        paddingVertical: 10, backgroundColor: appColors.lightBackgroundColor,
    },
    tabView: {
        marginRight: 8, paddingTop: 20, paddingBottom: 15, marginTop: 5, borderTopRightRadius: 26, borderTopLeftRadius: 26
    },
    tabText: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.largerFontSize,
        textAlign: 'center',
    },
    tabSelected: {
        justifyContent: 'center', alignItems: 'center', backgroundColor: appColors.lightBackgroundColor,
    },
    tabUnSelected: {
        justifyContent: 'center', alignItems: 'center', backgroundColor: appColors.light,
    },
    tabIndicator: {
        width: 70, backgroundColor: appColors.primary, height: 2
    },
    tabNonIndicator: {
        backgroundColor: appColors.lightPrimary, height: 2, right: 6,
    },
    tabSectionContainer: {
        backgroundColor: appColors.lightBackgroundColor, flex: 1
    },
    headerView: {
        flexDirection: 'row', alignItems: 'center', marginHorizontal: 10, marginVertical: 5
    },
    headerButtonInputContainerStyle: {
        backgroundColor: appColors.light, height: 50
    },
    headerButtonStyle: {
        borderRadius: 7, borderColor: appColors.primary, paddingHorizontal: 15
    },
    headerButtonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    listContainer: {
        marginHorizontal: 20, flexDirection: 'row', alignItems: 'center', backgroundColor: appColors.light, borderRadius: 8, marginBottom: 10
    },
    verticalIndicator: {
        width: 5, backgroundColor: appColors.primary, height: 50, borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
    },
    textContainer: {
        marginVertical: 5, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: appColors.light, borderRadius: 8, paddingLeft: 5, flex: 1
    },
    listFooterComponentStyle: { height: 30 },
    listFooterStyle: { paddingBottom: 20 }
})